module.exports = __webpack_public_path__ + "img/customer-risk.db842dc3.png";